import {ClientUserState} from '../../../../../shared/scripts/ClientUserState.ts'
import {UIMHeaderProfileController} from './UIMHeaderProfileController.ts'
import {setElementInnerHTML, setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils.ts'
import {UIHeaderController} from '../../../../../shared/scripts/ui_html/header/UIHeaderController.ts'
import {uiManager} from '../../../EntryMobile.ts'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class UIMHeaderController extends UIHeaderController {
    private readonly headerContainer: HTMLDivElement
    readonly profileController: UIMHeaderProfileController

    constructor() {
        super()
        this.headerContainer = document.getElementById('header-container') as HTMLDivElement
        this.profileController = new UIMHeaderProfileController()

        ClientUserState.registerChangeListener(() => {
            this.updateHeaderData()
        })
    }

    hide() {
        this.headerContainer.style.display = 'none'
    }

    show() {
        this.headerContainer.style.display = 'flex'
    }

    private updateHeaderData() {
        const profileContainer = document.getElementById('header-element-profile-container') as HTMLDivElement
        setElementOnClick(profileContainer, () => uiManager.mainpageController.profileOverlayController.show())

        if(ClientUserState.userState == undefined) return

        const userNameElement = document.getElementById('header-element-profile-name') as HTMLDivElement
        const karmaElement = document.getElementById('header-element-profile-karma') as HTMLDivElement

        userNameElement.innerText = ClientUserState.userState.username
        setElementInnerHTML(karmaElement, ClientUserState.userState.getPlayerKarmaStatusText())
        this.profileController.updateMembershipIcon(ClientUserState.userState)

        const iconElement = document.getElementById('header-element-profile-avatar') as HTMLImageElement

        UIMHeaderProfileController.updateIcon(ClientUserState.userState.icon, iconElement)
    }

    protected setupShuffleLinkInterceptor() {
        const notificationPanelContent = this.notificationPanelController.notificationPanelContent

        const setupLinks = () => {
            const shuffleLinks = notificationPanelContent.querySelectorAll('a[href*="#matchmakingqueue=16"]') as NodeListOf<HTMLLinkElement>

            shuffleLinks.forEach((link) => {
                if(link.hasAttribute('data-shuffle-handler')) return
                link.setAttribute('data-shuffle-handler', 'true')

                link.removeAttribute('href')

                setElementOnClick(link, () => {
                    this.notificationPanelController?.hideNotificationPanel()
                    void uiManager.goToMainPageAndSelectMatchType(MatchmakingMatchTypes.UnrankedShuffle)
                    UIMHeaderController.sendPlayNowClickAnalytic()
                }, true)
            })
        }

        setupLinks()
        setTimeout(() => setupLinks(), 1000)
    }
}
